<template>
<main-content>
    <kt-panel>
        <kt-panel-body>
            <ivr-update-form v-if="status !== 'loading'" :form_data="form_data" :submit="submit"></ivr-update-form>
        </kt-panel-body>
    </kt-panel>
</main-content>
</template>

<script>
import mainContent from '@/components/main-content'
import IVRUpdateForm from './components/udate-form'
import $ from 'jquery'
import { KTApp } from '@/plugins/core/app'
import { ivrService } from '@/common/api.service'
import { mapGetters } from 'vuex'
import {IvrSettlementVariant} from "@/constants/IvrSettlementVariant";
import {IvrShopType} from "@/constants/IvrShopType";

export default {
    components: {
        'main-content': mainContent,
        'ivr-update-form': IVRUpdateForm
    },
    computed: {
        ...mapGetters('ivr', [
            'form_data', 'status'
        ])
    },
    data() {
        return {
            'hashid': this.$route.params.hashid,
            phone_validate:false
        }
    },
    beforeRouteEnter (to, from, next) {
        next(vm => {
            vm.$store.dispatch('ivr/find', vm.hashid)
        })
    },
    methods: {
        submit(e) {
            // this.form_data.merchant_share_percent = $('#merchant_wage').val()
            // this.form_data.merchant_share_percent = 100;
            let form = $('#ivr_form');
            let btn = $('#submit_btn');
            if (this.form_data.ivr_shop_type===IvrShopType.IVR){
                this.phone_validate=true
            }

            form.validate({
                rules: {
                    farsi_name: {
                        required: true,
                    },
                    english_name: {
                        required: true,
                    },
                    category_code: {
                        required: true,
                    },
                    address: {
                        required: true,
                    },
                    phone_number: {
                        required:  this.phone_validate
                    },
                    sheba_number: {
                        required: true
                    },
                    merchant_share_percent: {
                        required: true
                    },
                    settlement_variant: {
                        required: true,
                    },
                    wallet_hashid: {
                        required: () => {
                            return this.form_data.settlement_variant === IvrSettlementVariant.CHARGE_WALLET;
                        },
                    },
                    ivr_shop_type:{
                        required:true
                    }
                },
            });

            if(! form.valid()) {
                return;
            }

            KTApp.progress(btn);

            let params = this.$store.getters['ivr/form_data'];
            // let form_data = new FormData
            ivrService.update(this.hashid, params).then(response => {
                this.$store.commit('ivr/clearFormData');
                this.$router.push('/gateways')
            })
            .catch(({response}) => {
                if(response.data) {
                    form.validate().showErrors(response.data.data)
                }
                this.showMsg(form, 'danger', response.data.message)
            })
            .finally(() => {
                KTApp.unprogress(btn)
            })
        },
    },
}
</script>

<style>

</style>